import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import HeroSection from './components/HeroSection';
import VehiclesSection from './components/VehiclesSection';
import ServicesSection from './components/ServicesSection';
import FinancingSection from './components/FinancingSection';
import ReviewsSection from './components/ReviewsSection';
import ContactSection from './components/ContactSection';
import { useEffect } from 'react';
import { applySeo } from '@/lib/seo';

export default function Home() {
  useEffect(() => {
    applySeo({
      title: "Easy Car | Voitures d'occasion à La Réunion",
      description: "Découvrez les voitures d'occasion Easy Car à La Réunion, au Tampon et à Saint-Pierre. Véhicules révisés, financement, garantie et accompagnement administratif.",
      canonical: "https://easycar.re/",
    });

    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <VehiclesSection />
        <ServicesSection />
        <FinancingSection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}